import { getServerConfig } from '@app/origami-api/server-config';

export class ValidationRegex {
  static readonly url = /(http|https):\/\/(\w+:?\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%\-\/]))?/;
  static get email(): RegExp {
    return getServerConfig().EmailValidationRegexp;
  }
  static readonly phone = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i;
  static readonly folderNameReserved = /^[^<>:"\/\\\|\?\*]*[^.<>:"\/\\\|\?\*]$/;
}
